import { render, staticRenderFns } from "./AdminActionHistory.vue?vue&type=template&id=b2cb477c&scoped=true&lang=pug"
import script from "./AdminActionHistory.vue?vue&type=script&lang=js"
export * from "./AdminActionHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminActionHistory.vue?vue&type=style&index=0&id=b2cb477c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cb477c",
  null
  
)

export default component.exports